<template>
  <div class="buttonlist">
    <div class="buttonlist-m">
      <el-form :inline="true" :model="filteForm" class="demo-form-inline toolbar" style="padding-bottom: 0" @submit.native.prevent>
        <el-form-item label="老人姓名">
          <el-input v-model.trim="filteForm.oldmanNameKeyword" placeholder="姓名/床位" clearable @keyup.enter.native="onSubmit" />
        </el-form-item>
        <el-form-item label="执行日期">
          <el-date-picker v-model="filteForm.dateRange" type="daterange" range-separator="至" value-format="yyyy-MM-dd" style="width:240px" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" plain @click="onSubmit">查询</el-button>
          <el-button type="warning" plain class="el-icon-plus" @click="showAdd">补录记录</el-button>
          <el-button type="info" icon="el-icon-download" plain @click="exportExcel">导出</el-button>
        </el-form-item>
      </el-form>
      <div v-loading="loading">
        <el-table :data="dataList" :row-style="tableRowStyle" :header-cell-style="tableHeaderColor">
          <el-table-column label="记录编号" prop="recordNo" align="center" width="150" />
          <el-table-column label="老人" prop="oldmanName" align="center" width="90" />
          <el-table-column label="床位" prop="bedNo" align="center" width="80" />
          <el-table-column label="护理项目" prop="projectName" align="center" />
          <el-table-column label="执行日期" prop="execDate" align="center" width="110" />
          <el-table-column label="执行人" prop="executorName" align="center" width="90" />
          <el-table-column label="类型" align="center" width="90">
            <template slot-scope="s">{{ s.row.recordType === 2 ? '补录' : '自动' }}</template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="200" fixed="right">
            <template slot-scope="s">
              <el-button type="warning" size="mini" plain @click="showEdit(s.row)">修改</el-button>
              <el-button type="danger" size="mini" plain @click="handleDelete(s.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background @current-change="handleCurrentChange" :current-page="filteForm.pageNum"
          layout="total, prev, pager, next" :total="totalDataNumber" align="center" class="fenye" />
      </div>
      <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="560px" :close-on-click-modal="false">
        <el-form :model="form" label-width="100px">
          <template v-if="!isEdit">
            <el-form-item label="老人姓名" required>
              <el-autocomplete v-model.trim="form.oldmanName" style="width:100%" :fetch-suggestions="queryOlder" @select="selectOld" />
            </el-form-item>
            <el-form-item label="护理项目" required>
              <el-select v-model="form.projectId" filterable style="width:100%" @change="onProjectChange">
                <el-option v-for="p in projectList" :key="p.id" :label="p.projectName" :value="p.id" />
              </el-select>
            </el-form-item>
            <el-form-item label="执行日期" required>
              <el-date-picker v-model="form.execDate" type="date" value-format="yyyy-MM-dd" style="width:100%" />
            </el-form-item>
            <el-form-item label="开始时间" required>
              <el-date-picker v-model="form.startTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" style="width:100%" />
            </el-form-item>
            <el-form-item label="结束时间" required>
              <el-date-picker v-model="form.endTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" style="width:100%" />
            </el-form-item>
            <el-form-item label="执行人" required>
              <el-input v-model.trim="form.executorName" />
            </el-form-item>
          </template>
          <el-form-item label="备注">
            <el-input v-model.trim="form.remark" type="textarea" :rows="2" />
          </el-form-item>
          <el-form-item v-if="isEdit" label="结束时间">
            <el-date-picker v-model="form.endTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" style="width:100%" />
          </el-form-item>
        </el-form>
        <div slot="footer" align="center">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" :loading="submitLoading" @click="submitForm">确定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { postDownload } from "@/utils/request.js";
export default {
  name: "NursingCareRecordList",
  data() {
    return {
      filteForm: { oldmanNameKeyword: "", dateRange: null, pageNum: 1, pageSize: 20 },
      dataList: [],
      totalDataNumber: 0,
      loading: false,
      projectList: [],
      dialogVisible: false,
      dialogTitle: "",
      isEdit: false,
      form: {},
      submitLoading: false
    };
  },
  methods: {
    onSubmit() { this.filteForm.pageNum = 1; this.getTableData(); },
    buildQuery() {
      const p = { pageNum: this.filteForm.pageNum, pageSize: this.filteForm.pageSize, oldmanNameKeyword: this.filteForm.oldmanNameKeyword };
      if (this.filteForm.dateRange && this.filteForm.dateRange.length === 2) {
        p.execDateStart = this.filteForm.dateRange[0];
        p.execDateEnd = this.filteForm.dateRange[1];
      }
      return p;
    },
    getTableData() {
      this.loading = true;
      this.$postJson("omc/nursingCareRecord/queryListWithPage", this.buildQuery()).then(res => {
        this.loading = false;
        if (res.code == 200 && res.result) {
          this.dataList = res.result.list || [];
          this.totalDataNumber = res.result.total || 0;
        }
      }).catch(() => { this.loading = false; });
    },
    exportExcel() { postDownload("omc/nursingCareRecord/export", "护理记录.xls", this.buildQuery()); },
    showAdd() {
      this.isEdit = false;
      this.dialogTitle = "手动补录护理记录";
      this.form = { remark: "" };
      this.dialogVisible = true;
    },
    showEdit(row) {
      this.isEdit = true;
      this.dialogTitle = "修改护理记录";
      this.form = { id: row.id, remark: row.remark, endTime: row.endTime };
      this.dialogVisible = true;
    },
    queryOlder(q, cb) {
      if (!q) return cb([]);
      this.$postJson("omc/queryMachine/queryOldmanList", { oldName: q, pageNum: 1, pageSize: 20 }).then(res => {
        const list = (res.result && res.result.list) ? res.result.list : [];
        cb(list.map(o => ({ value: o.oldName, old: o })));
      });
    },
    selectOld(item) {
      this.form.oldmanId = item.old.oldId;
      this.form.oldmanName = item.old.oldName;
      this.form.bedNo = item.old.bedNo || item.old.roomBed;
    },
    onProjectChange(id) {
      const p = this.projectList.find(x => x.id === id);
      if (p) this.form.projectName = p.projectName;
    },
    submitForm() {
      this.submitLoading = true;
      const url = this.isEdit ? "omc/nursingCareRecord/modify" : "omc/nursingCareRecord/addManual";
      this.$postJson(url, this.form).then(res => {
        this.submitLoading = false;
        if (res.code == 200) {
          this.$message.success("保存成功");
          this.dialogVisible = false;
          this.getTableData();
        } else this.$message.error(res.message);
      }).catch(() => { this.submitLoading = false; });
    },
    handleDelete(row) {
      this.$prompt("请输入删除原因", "删除确认", { inputPattern: /.+/, inputErrorMessage: "原因必填" }).then(({ value }) => {
        this.$postJson("omc/nursingCareRecord/softDelete", { id: row.id, deleteReason: value }).then(res => {
          if (res.code == 200) { this.$message.success("已删除"); this.getTableData(); }
          else this.$message.error(res.message);
        });
      });
    },
    handleCurrentChange(v) { this.filteForm.pageNum = v; this.getTableData(); },
    tableRowStyle() { return "background-color:#fff"; },
    tableHeaderColor({ rowIndex }) {
      if (rowIndex === 0) return "color:#2d2d2d;font-weight:600;text-align:center;font-size:14px;background-color:#d4f5fa;";
    },
    loadProjects() {
      this.$postJson("omc/nursingProject/queryListWithPage", { pageNum: 1, pageSize: 500, status: 1 }).then(res => {
        this.projectList = (res.result && res.result.list) ? res.result.list : [];
      });
    }
  },
  mounted() {
    this.loadProjects();
    this.getTableData();
    const action = this.$route.meta && this.$route.meta.recordAction;
    if (action === "add") this.$nextTick(() => this.showAdd());
  }
};
</script>
<style lang="scss" scoped>
.buttonlist .buttonlist-m { padding: 10px 0 0 5px; }
.fenye { margin-top: 12px; }
</style>
